import React from 'react';

const GlobalProjects = () => {
  const regions = [
    { name: "North America", projects: 45, icon: "fas fa-flag-usa" },
    { name: "Middle East", projects: 38, icon: "fas fa-mosque" },
    { name: "Central Asia", projects: 22, icon: "fas fa-mountain" },
    { name: "Europe", projects: 15, icon: "fas fa-european-union" }
  ];

  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Global Project Experience</h2>
          <p className="text-xl text-gray-600">Projects across North America, Middle East, Central Asia</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {regions.map((region, index) => (
            <div key={index} className="text-center">
              <i className={`${region.icon} text-5xl text-blue-600 mb-4 block`}></i>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">{region.name}</h3>
              <p className="text-4xl font-bold text-blue-600">{region.projects}+</p>
              <p className="text-gray-600">Projects Completed</p>
            </div>
          ))}
        </div>
        
        <div className="bg-gray-50 p-12 rounded-lg">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <h4 className="text-5xl font-bold text-blue-600 mb-2">120+</h4>
              <p className="text-gray-700 font-semibold">Total Projects</p>
            </div>
            <div>
              <h4 className="text-5xl font-bold text-green-600 mb-2">15+</h4>
              <p className="text-gray-700 font-semibold">Years Experience</p>
            </div>
            <div>
              <h4 className="text-5xl font-bold text-purple-600 mb-2">98%</h4>
              <p className="text-gray-700 font-semibold">Client Satisfaction</p>
            </div>
          </div>
        </div>
        
        <div className="mt-12 relative">
          <img
            src="/assets/asset-18.jpg"
            alt="World map highlights"
            className="w-full rounded-lg shadow-xl"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-white/80 to-transparent rounded-lg"></div>
        </div>
      </div>
    </section>
  );
};

export default GlobalProjects;
